var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"callout",class:{
    'callout--danger': _vm.type === _vm.allowedCalloutTypes.DANGER,
    'callout--warning': _vm.type === _vm.allowedCalloutTypes.WARNING,
    'callout--certificate': _vm.type === _vm.allowedCalloutTypes.CERTIFICATE,
  }},[_c('div',{staticClass:"callout__content"},[_vm._t("content")],2),(_vm.hasCloseButton)?_c('Icon',{staticClass:"callout__icon",attrs:{"name":"close","size":24},nativeOn:{"click":function($event){return _vm.onCloseClick.apply(null, arguments)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }